"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDown = void 0;
const React = require("react");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const Modal_1 = require("./Modal");
const layout_1 = require("../modules/layout");
const theme_1 = require("../modules/theme");
const test_1 = require("../modules/test");
const react_native_1 = require("react-native");
class DropDownItem extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                modalItem: {
                    paddingHorizontal: 16,
                    paddingVertical: 16,
                    fontFamily: theme.fontFamily1,
                    fontSize: 16,
                    color: theme.dropDownTextColor
                },
                icon: {
                    fontSize: 26
                },
                rowView: {
                    flexDirection: 'row'
                },
                iconView: {
                    width: 100,
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                iconOnlyView: {
                    width: 200,
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                iconOnly: {
                    paddingHorizontal: 16,
                    paddingVertical: 16,
                    fontSize: 60
                }
            });
            return styles;
        };
        this.renderOpenDropDownItem = () => {
            const { label, icon, iconComponent, nativeID } = this.props;
            const theme = (0, theme_1.getTheme)();
            const styles = this.getStyles();
            if (label && icon) {
                return (React.createElement(react_native_1.View, { nativeID: nativeID, style: styles.rowView },
                    React.createElement(react_native_1.View, { style: styles.iconView }, iconComponent ? (React.createElement(iconComponent, {
                        name: icon,
                        style: styles.icon,
                        color: theme.textColor1
                    })) : (React.createElement(FontAwesome_1.default, { name: icon, color: theme.textColor1, style: styles.icon }))),
                    React.createElement(react_native_1.View, null,
                        React.createElement(react_native_1.Text, { style: styles.modalItem }, label))));
            }
            else if (label && !icon) {
                return (React.createElement(react_native_1.View, { nativeID: nativeID, style: styles.rowView },
                    React.createElement(react_native_1.Text, { style: styles.modalItem }, label)));
            }
            else if (!label && icon) {
                return (React.createElement(react_native_1.View, { nativeID: nativeID, style: styles.iconOnlyView }, iconComponent ? (React.createElement(iconComponent, {
                    name: icon,
                    style: styles.iconOnly,
                    color: theme.textColor1
                })) : (React.createElement(FontAwesome_1.default, { name: icon, color: theme.textColor1, style: styles.iconOnly }))));
            }
            return null;
        };
    }
    render() {
        const { first, last, value, onPress, nativeID } = this.props;
        const theme = (0, theme_1.getTheme)();
        return (React.createElement(react_native_1.TouchableHighlight, { onPress: () => onPress(value), testID: (0, test_1.getTestID)(nativeID), underlayColor: theme.backgroundColor2, style: {
                borderTopLeftRadius: first ? 5 : 0,
                borderTopRightRadius: first ? 5 : 0,
                borderBottomLeftRadius: last ? 5 : 0,
                borderBottomRightRadius: last ? 5 : 0
            } }, this.renderOpenDropDownItem()));
    }
}
class DropDown extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            modalOpen: false
        };
        this.handleItemPress = (value) => {
            const { onChange } = this.props;
            this.setState({ modalOpen: false });
            onChange(value);
        };
        this.renderClosedDropDown = (item, inputStyle) => {
            const { iconComponent } = this.props;
            const theme = (0, theme_1.getTheme)();
            const styles = this.getStyles();
            if (!item) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(react_native_1.Text, { style: [styles.text, inputStyle] }, "-"),
                    React.createElement(FontAwesome_1.default, { name: "caret-down", style: styles.seta })));
            }
            else if (item.label && item.icon) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(react_native_1.View, { style: styles.rowView },
                        React.createElement(react_native_1.View, { style: styles.iconView }, iconComponent ? (React.createElement(iconComponent, {
                            name: item.icon,
                            style: styles.icon,
                            color: theme.textColor1
                        })) : (React.createElement(FontAwesome_1.default, { name: item.icon, color: theme.textColor1, style: styles.icon }))),
                        React.createElement(react_native_1.Text, { style: [styles.textIcon, inputStyle] }, item.label)),
                    React.createElement(FontAwesome_1.default, { name: "caret-down", style: styles.seta })));
            }
            else if (item.label && !item.icon) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(react_native_1.Text, { style: [styles.text, inputStyle] }, item.label),
                    React.createElement(FontAwesome_1.default, { name: "caret-down", style: styles.seta })));
            }
            else if (!item.label && item.icon) {
                return (React.createElement(React.Fragment, null,
                    iconComponent ? (React.createElement(iconComponent, {
                        name: item.icon,
                        style: styles.iconOnly,
                        color: theme.textColor1
                    })) : (React.createElement(FontAwesome_1.default, { name: item.icon, color: theme.textColor1, style: styles.iconOnly })),
                    React.createElement(FontAwesome_1.default, { name: "caret-down", style: styles.setaIcone })));
            }
            return null;
        };
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const { icon } = this.props;
            const styles = react_native_1.StyleSheet.create({
                container: Object.assign({ paddingHorizontal: 16, paddingVertical: 8, borderWidth: 1, borderColor: theme.borderColor1, borderRadius: 3 }, (icon
                    ? {
                        flexDirection: 'row',
                        minHeight: react_native_1.Platform.OS === 'web' || react_native_1.Platform.OS === 'ios' ? 40 : 46
                    }
                    : {})),
                label: {
                    color: theme.textColor2,
                    fontFamily: theme.fontFamily3,
                    fontSize: (0, layout_1.isTablet)() ? 15 : 12,
                    lineHeight: 16
                },
                text: {
                    lineHeight: (0, layout_1.isTablet)() ? 28 : 22,
                    minHeight: (0, layout_1.isTablet)() ? 28 : 22,
                    textAlignVertical: 'center',
                    color: theme.textColor1,
                    fontFamily: theme.fontFamily1,
                    fontSize: 16
                },
                textIcon: {
                    height: 27,
                    alignSelf: 'center',
                    color: theme.textColor1,
                    fontFamily: theme.fontFamily1,
                    fontSize: 16
                },
                seta: {
                    color: theme.textColor1,
                    fontSize: 16,
                    position: 'absolute',
                    bottom: 10,
                    right: 16
                },
                setaIcone: {
                    color: theme.textColor1,
                    fontSize: 16,
                    position: 'absolute',
                    bottom: 25,
                    right: 16
                },
                modalOverlay: {
                    justifyContent: 'center'
                },
                modalContainer: {
                    borderRadius: 5,
                    backgroundColor: theme.backgroundColor1,
                    margin: 16
                },
                modalItem: {
                    paddingHorizontal: 16,
                    paddingVertical: 16,
                    fontFamily: theme.fontFamily1,
                    fontSize: 16
                },
                emptyMessageContainer: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    paddingHorizontal: 16
                },
                readonly: {
                    backgroundColor: theme.disabledColor
                },
                icon: {
                    fontSize: 26
                },
                rowView: {
                    flexDirection: 'row'
                },
                iconView: {
                    width: 50,
                    alignItems: 'center'
                },
                iconOnlyView: {
                    width: 200,
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                iconOnly: {
                    paddingHorizontal: 16,
                    paddingVertical: 8,
                    fontSize: 26
                },
                iconOnLine: {
                    color: theme.textColor2,
                    fontSize: (0, layout_1.isTablet)() ? 21 : 19,
                    marginRight: 10,
                    minWidth: 25,
                    textAlignVertical: 'center',
                    flex: 0
                }
            });
            return styles;
        };
    }
    render() {
        const { modalOpen } = this.state;
        const { label, items, value, emptyMessage, style, disabled, labelStyle, inputStyle, iconComponent, nativeID, icon } = this.props;
        const selectedItem = items.find(x => x.value === value);
        const styles = this.getStyles();
        const theme = (0, theme_1.getTheme)();
        return (React.createElement(react_native_1.TouchableWithoutFeedback, { onPress: () => this.setState({ modalOpen: true }), disabled: disabled },
            React.createElement(react_native_1.View, { nativeID: nativeID, testID: (0, test_1.getTestID)(nativeID), style: [styles.container, style, disabled ? styles.readonly : null] },
                icon ? (React.createElement(FontAwesome_1.default, { name: icon, style: styles.iconOnLine })) : (React.createElement(react_native_1.Text, { style: [styles.label, labelStyle] }, label)),
                this.renderClosedDropDown(selectedItem, inputStyle),
                React.createElement(Modal_1.Modal, { visible: modalOpen, onRequestClose: () => this.setState({ modalOpen: false }), overlayStyle: styles.modalOverlay },
                    React.createElement(react_native_1.TouchableWithoutFeedback, null,
                        React.createElement(react_native_1.View, { style: [
                                styles.modalContainer,
                                react_native_1.Platform.OS === 'web' && {
                                    marginVertical: '10px',
                                    marginHorizontal: 'auto',
                                    width: '90%',
                                    maxWidth: 450,
                                    maxHeight: 300,
                                    justifyContent: 'center'
                                }
                            ] }, items.length > 0 ? (React.createElement(react_native_1.FlatList, { data: items, initialNumToRender: items.length, keyExtractor: item => item.value.toString(), renderItem: ({ item, index }) => {
                                return (React.createElement(DropDownItem, { nativeID: item.nativeID, first: index === 0, last: index === items.length - 1, label: item.label, value: item.value, onPress: this.handleItemPress, icon: item.icon, iconComponent: iconComponent }));
                            } })) : (React.createElement(react_native_1.View, { style: styles.emptyMessageContainer },
                            React.createElement(FontAwesome_1.default, { name: "warning", color: theme.warningColor, size: 24 }),
                            React.createElement(react_native_1.Text, { style: styles.modalItem }, emptyMessage)))))))));
    }
}
exports.DropDown = DropDown;
DropDown.defaultProps = {
    emptyMessage: 'Não há registros cadastrados'
};
